export enum InspectionResultActionTypeEnum {
  BLOCK_KNM = 'BLOCK_KNM',
  LIGHT_RED = 'LIGHT_RED',
  LIGHT_YELLOW = 'LIGHT_YELLOW',
}
